module.exports = __webpack_public_path__ + "static/media/m1_sf_13.f18eb8b0.png";